module.exports = new __parcel__URL__("noResultsLight.5ffcf568.svg").toString();